import script from "./VerificationRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationRecords.vue?vue&type=script&setup=true&lang=js"

import "./VerificationRecords.vue?vue&type=style&index=0&id=4615330b&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4615330b"]])

export default __exports__